<template>
  <div class="wrapper-feedback wh100p">
    <section class="section-navs df">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('feedback.feedbackList')}}</div>
      </div>
    </section>
    <!-- 数据表格 -->
    <section class="section-table">
      <div class="table-box" ref="tablebox">
        <el-table
          :data="tableDatas"
          :max-height="tableMaxHeight">
          <!-- :row-class-name="tableRowClassName" -->
          <!-- stripe border highlight-current-row -->
          <el-table-column
            show-overflow-tooltip v-for="(x,i) in tableOptions" :key="i"
            :prop="x.key" :label="$t('feedback.'+x.key)" :min-width="x.width||'80'" :align="x.align||'center'"></el-table-column>
          <el-table-column :label="$t('feedback.status')" min-width="80" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.status<=1?'_redcolor':''">{{$t('feedback.status'+scope.row.status)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('feedback.dealPerson')" prop="dealPerson" min-width="80" align="center"></el-table-column>
          <el-table-column :label="$t('common.action')" min-width="80" align="center">
            <template slot-scope="scope">
              <div class="themebtn-xs" @click="viewDetail(scope.row.id)">{{$t('common.detail')}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagenation :pageData="pageData" @pageChange="pageChange" />
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin_table_simple from '@/mixins/mixin_table_simple'
export default {
  name: 'feedback',
  mixins: [mixin_table_simple],
  data() {
    return {
      tableOptions: [
        { key: 'index', label: '序號', width: '60' },
        { key: 'shortdate', label: '日期', width: '120' },
        { key: 'title', label: '標題', width: '180' },
        { key: 'content', label: '內容', width: '180' },
      ],
      tableDatas: [],

      otherHeight: 260,
    }
  },
  computed: {
    ...mapState(['newFeedbackComing_x']),
  },
  watch: {
    newFeedbackComing_x(n, o) {
      this.init()
    },
  },
  methods: {
    // 查看詳情
    viewDetail(id) {
      this.$router.push(`feedbackDetail?id=${id}`)
    },
    async getTableData() {
      const _R = await this.getData('feedback', {
        type: 1,
        shopId: this.currentShopId,
        companyId: this.shop_x.companyId,
        parentId: 0,
        sortField: ['createTime'],
        sortType: 'DESC',
        pageSize: this.pageData.pageSize,
        pageNumber: this.pageData.currentPage,
      }, { replace: true })
      console.log(`%c反馈:`, 'color: #00f;', _R)
      this.tableDatas = _R.map((x, i) => {
        x.index = i + 1
        x.shortdate = x.createDate.substr(5,11).replace('-','/')
        return x
      })
    },
    // 获取数据
    async init() {
      this.getTableData()
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/util_table.scss';
// .wrapper-feedback{padding: 20px 0 0 20px;box-sizing: border-box;}
.section-title{height: 80px;line-height: 80px;background: #fff;padding-left: 20px;margin-bottom: 20px;font-weight: bold;}
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
}

.section-table{
  height: calc(100% - 100px);
  .table-box{height: calc(100% - 100px);overflow: hidden scroll;}
}
</style>